export const FETCH_FILE_DATA_SUCCESS = 'FETCH_FILE_DATA_SUCCESS';

export const FETCH_FILE_DATA_FAILURE = 'FETCH_FILE_DATA_FAILURE';